import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './ShopDiscover.scss';

import { syncShopFeatures } from '../../Actions/FeaturedActions';

import ScrollToTop from '../../Components/General/ScrollToTop';
import ShopDiscoverHeader from '../../Components/Shop/ShopDiscoverHeader';
import ShopDiscoverResults from '../../Components/Shop/ShopDiscoverResults';
import ShopDiscoverTabs from '../../Components/Shop/ShopDiscoverTabs';

const ShopDiscover = props => {
  // Tab Options
  const tab = props.match?.params?.tab;

  // Active Section
  const [activeSection, setActiveSection] = React.useState();

  // Sync Data
  React.useEffect(() => {
    props.syncShopFeatures();
  }, []);

  // Tab Events
  React.useEffect(() => {
    window.__ADD_EVENT__('Shop - Discover - Viewed Tab', { tab });
  }, [tab]);

  // Show tabs
  const showTabs = ['categories', 'brands'].includes(tab);

  return (
    <div className='shop-discover-outer-container'>
      <ScrollToTop />
      <div className='shop-discover-inner-container'>
        <div className='shop-discover-header-outer-container'>
          <ShopDiscoverHeader tab={tab} activeSection={activeSection} />
        </div>
        {showTabs && (
          <div className='shop-discover-tabs-outer-container'>
            <ShopDiscoverTabs tab={tab} activeSection={activeSection} setActiveSection={setActiveSection} />
          </div>
        )}
        <div className='shop-discover-results-outer-container'>
          <ShopDiscoverResults tab={tab} activeSection={activeSection} />
        </div>
      </div>
    </div>
  );
};

ShopDiscover.propTypes = {
  user: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {
  syncShopFeatures
})(ShopDiscover);
